import { FC } from 'react'

import { InputSelectControlField } from '@sequencehq/core-components'
import { ValidationResult } from 'Automations/nodeDefinitions/validation'
import { useCurrencyOptions } from '../hooks/useCurrencyOptions'

export const CurrencySelector: FC<{
  'data-testid'?: string
  value: string
  onChange: (value: string) => void
  validationErrors: ValidationResult[] | undefined
}> = ({ 'data-testid': dataTestId, value, onChange, validationErrors }) => {
  const options = useCurrencyOptions()

  return (
    <InputSelectControlField
      data-testid={dataTestId}
      value={value ?? ''}
      onChange={val => onChange(val as string)}
      options={options}
      placeholder="Select currency..."
      validationErrors={
        validationErrors?.map(e => ({ message: e.message })) ?? []
      }
    />
  )
}
